import { render, staticRenderFns } from "./Autoplay.vue?vue&type=template&id=4df54026&"
import script from "./Autoplay.vue?vue&type=script&lang=js&"
export * from "./Autoplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/production/spf-sexosafe-ezplatform/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4df54026')) {
      api.createRecord('4df54026', component.options)
    } else {
      api.reload('4df54026', component.options)
    }
    module.hot.accept("./Autoplay.vue?vue&type=template&id=4df54026&", function () {
      api.rerender('4df54026', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/SPFPlayer/lib/Autoplay.vue"
export default component.exports